import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import style from "./AppoinmentCreation.module.css";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import techToMed from "../../assets/images/techtomedix-logo.png";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Api from "../../utils/Api";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { calculateAge, dateFormatter, getAuthToken, isValEmpty } from "../../utils/CommonUtil";

export class AppointmentNotesSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRow: {},
            shareEmail: "",
            isLoading: "",
            successMessage: "",
            errorMessage: ""
        }
    }
    toggle = (obj) => {
        this.setState(
            (prevState) => ({
                selectedRow: obj ? obj : {},
                isModalOpen: !prevState.isModalOpen,
                shareEmail: ""
            }));
    };


    //Share via email
    shareViaEmail = async () => {
        this.setState({
            isLoading: true,
        });

        // headers
        const headers = {
            Authorization:
                "Bearer " + getAuthToken(),
        };
        const payload = {
            associated_related_party_id: this.props.data.assoRelatedParty,
            requested_related_party_id: this.props.data.reqProfessional,
            lk_document_type_id: this.state.selectedRow.lk_document_type_id,
            email: this.state.shareEmail,
            conductappointment_notes_id: this.state.selectedRow.conductappointment_notes_id
        }

        try {
            const response = await Api.post("appointment/notes/shareViaEmail", payload, {
                headers: headers,
            });

            if (response.status === 200) {
                this.setState({
                    isLoading: false,
                    successMessage: "Email sent successfully!",
                });

                setTimeout(() => {
                    this.setState({
                        successMessage: "",
                    });
                }, 2000);
            }
        } catch (error) {
            console.log("Error in share via email payment", error);
            this.setState({
                isLoading: false,
                errorMessage: "Error in email sent",
            });
            setTimeout(() => {
                this.setState({
                    errorMessage: "",
                });
            }, 2000);
        }
    };

    // Downloading attached documents api

    downloadFile = async () => {
        let notesType =
            this.state.selectedRow.lk_document_type_id === 1
                ? "Doctor Note"
                : this.state.selectedRow.lk_document_type_id === 2
                    ? "Referral Note"
                    : "Prescription";
        this.setState({
            isLoading: true,
        });
        // headers
        const headers = {
            Authorization:
                "Bearer " + getAuthToken(),
            Accept: "application/pdf",
        };

        const payload = {
            associated_related_party_id: this.props.data.assoRelatedParty,
            requested_related_party_id: this.props.data.reqProfessional,
            lk_document_type_id: this.state.selectedRow.lk_document_type_id,
            conductappointment_notes_id: this.state.selectedRow.conductappointment_notes_id
        };
        if(this.props.data.appointment_id){
            payload.appointment_id = this.props.data.appointment_id;
        }

        try {
            const response = await Api.post("appointment/notes/download", payload, {
                headers: headers,
                responseType: "blob",
            });

            if (response.status === 200) {
                this.setState({
                    isLoading: false,
                    successMessage: "Attached document download successfully",
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let name = this.props.data.patientDetail && this.props.data.patientDetail.name ? (notesType + "-" + this.props.data.patientDetail.name) : notesType;
                link.setAttribute("download", `${name}.pdf`);
                document.body.appendChild(link);
                link.click();

                setTimeout(() => {
                    this.setState({
                        successMessage: "",
                    });
                }, 2000);
            }
        } catch (error) {
            console.log("Error in download", error);
            this.setState({
                isLoading: false,
                errorMessage: "Error in download",
            });
            setTimeout(() => {
                this.setState({
                    errorMessage: "",
                });
            }, 2000);
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        })
    }

    getNotes = () => {
        // if(isValEmpty(this.state.selectedRow && this.state.selectedRow.notes)){
        //      return "";
        // }
        // if(this.state.selectedRow && this.state.selectedRow.notes && JSON.parse(this.state.selectedRow.notes).indexOf('\n')){
            return(
                this.state.selectedRow.notes && JSON.parse(this.state.selectedRow.notes).split('\n').map((value, index) => {
                    return (
                        <p key={index}>
                        {value}
                        <br />
                        </p>
                    );
                    })
            );
        // }else{
        //     return( <p>{this.state.selectedRow && this.state.selectedRow.notes}</p> );
        // }
    }


    render() {
        const data = this.props.data;
        const practice_logo = this.props.data.practice_logo;
        const practitionerDetail = data.practitionerDetail;
        const patientDetail = data.patientDetail;
        return (
            <div>
                <ul className={style.attchmentDocList}>
                    {data && data.attachedDocuments && data.attachedDocuments.map((element, index) => (
                        <li key={element.conductappointment_notes_id}>
                            <div>
                                <i
                                    className={`fa fa-paperclip mr-2 ${style.attachmentIcon}`}
                                ></i>
                                {/* <span>{element.lk_document_type_id === 1 ? "Doctor Note": element.lk_document_type_id === 2 : "Referral Note" : ""}</span> */}
                                <span>
                                    {element.lk_document_type_id === 1
                                        ? "Doctor Note"
                                        : element.lk_document_type_id === 2
                                            ? "Referral Note"
                                            : "Prescription"}
                                </span>
                            </div>
                            <div>
                                {/* <i
                                    onClick={(e) =>
                                        this.downloadFile(
                                            element.appointment_id,
                                            element.lk_document_type_id
                                        )
                                    }
                                    className={`fa fa-download ${style.downloadIcon}`}
                                    aria-hidden="true"
                                ></i> */}
                                <i
                                    onClick={(e) =>
                                        this.toggle(element)
                                    }
                                    className={`fa fa-eye ${style.downloadIcon}`}
                                    aria-hidden="true"
                                ></i>
                            </div>
                        </li>
                    ))}
                    {(!data || !data.attachedDocuments || data.attachedDocuments.length === 0) && (
                        <li>
                            <p>No attached documents found</p>
                        </li>
                    )}
                </ul>
                <Modal
                    isOpen={this.state.isModalOpen}
                    toggle={this.toggle}
                    className="payment-history-modal"
                    centered
                >
                    <ModalHeader
                        toggle={this.toggle}
                        className={style.paymentModalHeader}
                    >
                        Notes - Information
                    </ModalHeader>
                    <ModalBody className={style.paymentHistoryModal}>
                        <div ref={(el) => (this.componentRef = el)}>
                            <div className="row d-print-block d-none">
                                <div className="col-md-12">
                                    {practice_logo && (
                                        <div className="logo-header d-print-flex flex-row justify-content-center ">
                                            <div className="print-logo text-center ">
                                                <img src={practice_logo} className="print-practice-logo" alt="TechToMed" />
                                            </div>
                                        </div>)}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h4>{this.state.selectedRow && (this.state.selectedRow.lk_document_type_id === 1
                                        ? "Doctor Note"
                                        : this.state.selectedRow.lk_document_type_id === 2
                                            ? "Referral Note"
                                            : "Prescription")}</h4>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-12 practice-notes-wrapper">
                                <div className="row">
    <div className="col-lg-12">
      <div className="row">
        <div className="col-md-8 col-print-6">
          <div className="row">
            <div className="col-md-12">
              <h6 className="mb-2">{practitionerDetail && practitionerDetail.name &&
                                    ("Dr. " + practitionerDetail.name + (practitionerDetail.surname ? " " + practitionerDetail.surname : ""))}</h6>
              <p className="mb-2"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12"><label>{practitionerDetail && practitionerDetail.physical_address}</label></div>
          </div>
          <div className="row">
            <div className="col-md-12"><label>Email: </label><span className="ml-3">{practitionerDetail && practitionerDetail.email}</span></div>
          </div>
          <div className="row">
            <div className="col-md-12"><label>Phone no.: </label><span className="ml-3">{practitionerDetail && practitionerDetail.contact}</span></div>
          </div>
        </div>
      </div>
    
      {this.state.selectedRow && this.state.selectedRow.lk_document_type_id === 2 && (
    <div className="row referral-to">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12 my-3"><label>Date: </label><span className="ml-3">{this.state.selectedRow.created_at ? dateFormatter(this.state.selectedRow.created_at) : "" }</span></div>
          </div>
          <div className="row">
            <div className="col-md-8 col-print-6">
              <div className="row">
                <div className="col-md-12">
                  <h6 className="mb-2">{"Dr. " + this.state.selectedRow.referred_doctor_name}</h6>
                  <p className="mb-2"></p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12 col-print-12">
                      <p>{this.state.selectedRow.referred_doctor_address}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12"><label>Email: </label><span className="ml-3">{this.state.selectedRow.referred_doctor_email}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      {/* <hr />
    </div>
  </div> */}
                                    {/* <div className="row">
                                        <div className="col-lg-12">
                                            <div className="row">
                                                <div className="col-md-6 col-xl-5 col-print-6">
                                                    <div className="row">
                                                        <div className="col-md-8">
                                                            <h6 className="mb-2">{practitionerDetail && practitionerDetail.name &&
                                                                ("Dr. " + practitionerDetail.name + (practitionerDetail.surname ? " " + practitionerDetail.surname : ""))}</h6>
                                                            <p className="mb-2"></p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12 col-print-12">{practitionerDetail && practitionerDetail.physical_address}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Email:</label></div>
                                                            <div className="col-md-6 col-print-6">{practitionerDetail && practitionerDetail.email}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Phone no.:</label></div>
                                                            <div className="col-md-6 col-print-6">{practitionerDetail && practitionerDetail.contact}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.selectedRow && this.state.selectedRow.lk_document_type_id === 2 && (
                                                <div className="row referral-to">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-6 col-xl-5 col-print-6 my-3">
                                                                <div className="row">
                                                                    <div className="col-md-6 col-print-6"><label>Date:</label></div>
                                                                    <div className="col-md-6 col-print-6">{this.state.selectedRow.created_at ? dateFormatter(this.state.selectedRow.created_at) : "" }</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-xl-5 col-print-6">
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        <h6 className="mb-2">{"Dr. " + this.state.selectedRow.referred_doctor_name}</h6>
                                                                        <p className="mb-2"></p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-12 col-print-12">{this.state.selectedRow.referred_doctor_address}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Email:</label></div>
                                                            <div className="col-md-6 col-print-6">{this.state.selectedRow.referred_doctor_email}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>)} */}
                                            <hr />
                                            {this.state.selectedRow && this.state.selectedRow.lk_document_type_id === 3 && (
                                                <div className="prescription-patient-details row mb-5">
                                                    <div className="col-md-6 col-lg-5 col-print-6">
                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Patient Name:</label></div>
                                                            <div className="col-md-6 col-print-6">{patientDetail && patientDetail.name ?
                                                             (patientDetail.name + (patientDetail.surname?" "+ patientDetail.surname: "")): "" }</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Patient Address:</label></div>
                                                            <div className="col-md-6 col-print-6">{patientDetail && patientDetail.physical_address}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-5 offset-lg-2 col-print-6">
                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Gender:</label></div>
                                                            <div className="col-md-6 col-print-6">{patientDetail && patientDetail.patient_gender}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>Age:</label></div>
                                                            <div className="col-md-6 col-print-6">{patientDetail && patientDetail.dob ? calculateAge(patientDetail.dob) : ""}</div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-print-6"><label>DOB:</label></div>
                                                            <div className="col-md-6 col-print-6">{patientDetail && patientDetail.dob? dateFormatter(patientDetail.dob): ""}</div>
                                                        </div>
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                           {(this.state.selectedRow && this.state.selectedRow.lk_document_type_id === 2) && ( <p className="note-greetings">Dear Doctor,</p>)}
                                            <div className="referral-msg note-message">
                                                    {this.getNotes()}
                                                {(this.state.selectedRow && this.state.selectedRow.lk_document_type_id === 2) && (<p className="pt-5">Your's Sincerely</p>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="doctor-sign">
                                                <label>{practitionerDetail && practitionerDetail.name &&
                                                    ("Dr. " + practitionerDetail.name + (practitionerDetail.surname ? " " + practitionerDetail.surname : ""))}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="row">
                                <div className="logo-footer d-print-block d-none col-md-12">
                                    <div className="print-logo text-center">
                                        <p>Powered By:</p>
                                        <img src={techToMed} className="print-ttm-logo" alt="TechToMed" />
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                {this.state.isLoading ? (
                                    <div className={style.loadingWrapper}>
                                        <img src={ttmLoader} alt="loader" className={style.loading} />
                                    </div>
                                ) : (
                                        <div>
                                            {this.state.successMessage && (
                                                <p className={style.successMessage}>
                                                    {this.state.successMessage}
                                                </p>
                                            )}
                                            {this.state.errorMessage && (
                                                <p className={style.errorMessage}>
                                                    {this.state.errorMessage}
                                                </p>
                                            )}
                                        </div>
                                    )}
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-12">
                           </div>
                        </div> */}
                        <div className="row">
                            <div
                                className={`col-lg-12 ${style.paymentHistoryModalBtnWrapper} d-flex flex-column flex-md-row`}
                            >
                                <div>
                                    {/* <Button className="form-primary-btn" onClick={this.toggle}>
                                        Cancel
                                </Button> */}
                                    <Formik
                                        initialValues={this.state}
                                        enableReinitialize={true}
                                        validationSchema={Yup.object().shape({
                                            shareEmail: Yup.string().required("Email is required")
                                                .matches(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, "Enter valid email")
                                                .nullable(),
                                        })}
                                        onSubmit={this.shareViaEmail}
                                    >
                                        {({ errors, status, touched }) => (
                                            <Form>
                                                <div className="d-flex flex-column flex-sm-row mb-3" >

                                                    <div className={`mr-3`}>

                                                        <div className="form-group">
                                                            <Field
                                                                name="shareEmail"
                                                                placeholder="Enter Email"
                                                                className={
                                                                    "form-control share-email" +
                                                                    (errors.shareEmail && touched.shareEmail
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                onChange={this.handleChange}
                                                                value={this.state.shareEmail}

                                                            >
                                                            </Field>
                                                            <ErrorMessage
                                                                name="shareEmail"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />

                                                        </div>
                                                    </div>
                                                    <div  >
                                                        <button
                                                            type="submit"
                                                            className="form-primary-btn"
                                                        >
                                                            Share
                                                    </button>

                                                    </div>
                                                </div>
                                            </Form>
                                        )}

                                    </Formik>

                                </div>
                                <div>
                                    <Button
                                        className="form-primary-btn mr-4"
                                        onClick={this.downloadFile}
                                    >
                                        Download
                                 </Button>
                                    {/* <Button className="form-primary-btn">Print</Button> */}
                                    <ReactToPrint
                                        trigger={() => (
                                            <Button className="form-primary-btn">Print</Button>
                                        )}
                                        content={() => this.componentRef}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

            </div>
        );
    }

}





